import { applyI18n } from '../../i18n';
import { bindLocaleRefresh } from '../../i18n/bindLocaleRefresh';
import { dialogHelpTopic } from '../../help/dialogHelpTopics';
import { bindModalDismiss, createModalShell } from '../../ui/modalDialogShell';
import { downloadSedrTemplate, showSedrImportWizard } from './SedrImportWizard';

/** Slim import hub for starter-set items (file + template only). */
export function showSedrLibraryImportHubDialog(options: {
  setId: string;
  onDone: () => void;
}): void {
  const shell = createModalShell({
    titleKey: 'sedr.import.hubTitle',
    titleId: 'sedr-library-import-hub-title',
    helpTopic: dialogHelpTopic('sedrLibraryImport'),
    className: 'sedr-import-hub-dialog',
  });

  shell.body.innerHTML = `
    <div class="sedr-import-hub">
      <section class="sedr-import-hub__section">
        <div class="sedr-import-hub__copy">
          <h3 data-i18n="sedr.import.hubFile"></h3>
          <p class="muted" data-i18n="sedr.import.hubFileHint"></p>
        </div>
        <button type="button" class="button primary" id="sedr-library-import-file" data-i18n="sedr.import.hubFile"></button>
      </section>
      <section class="sedr-import-hub__section">
        <div class="sedr-import-hub__copy">
          <h3 data-i18n="sedr.import.hubTemplate"></h3>
          <p class="muted" data-i18n="sedr.import.hubTemplateHint"></p>
        </div>
        <button type="button" class="button subtle" id="sedr-library-import-template" data-i18n="sedr.import.hubTemplate"></button>
      </section>
    </div>
  `;

  const closeButton = document.createElement('button');
  closeButton.type = 'button';
  closeButton.className = 'button ghost';
  closeButton.setAttribute('data-i18n', 'sedr.import.hubClose');
  shell.actions.append(closeButton);

  document.body.append(shell.backdrop);
  applyI18n(shell.dialog);

  const unbindLocale = bindLocaleRefresh(() => applyI18n(shell.dialog));

  const close = () => {
    unbindLocale();
    unbindDismiss();
    shell.backdrop.remove();
  };

  const unbindDismiss = bindModalDismiss({
    backdrop: shell.backdrop,
    closeButton: shell.closeButton,
    onClose: close,
  });

  closeButton.addEventListener('click', close);

  shell.body.querySelector('#sedr-library-import-file')?.addEventListener('click', () => {
    close();
    showSedrImportWizard({ starterSetId: options.setId }, options.onDone);
  });

  shell.body.querySelector('#sedr-library-import-template')?.addEventListener('click', () => {
    downloadSedrTemplate();
  });
}
